/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { JumboStructsEDRAccountData } from './JumboStructsEDRAccountData';
import {
    JumboStructsEDRAccountDataFromJSON,
    JumboStructsEDRAccountDataFromJSONTyped,
    JumboStructsEDRAccountDataToJSON,
} from './JumboStructsEDRAccountData';

/**
 * 
 * @export
 * @interface JumboStructsEDRAccountResult
 */
export interface JumboStructsEDRAccountResult {
    /**
     * 
     * @type {string}
     * @memberof JumboStructsEDRAccountResult
     */
    createdAt?: string;
    /**
     * 
     * @type {JumboStructsEDRAccountData}
     * @memberof JumboStructsEDRAccountResult
     */
    data?: JumboStructsEDRAccountData;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsEDRAccountResult
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof JumboStructsEDRAccountResult
     */
    invalidatedAt?: string;
    /**
     * 
     * @type {boolean}
     * @memberof JumboStructsEDRAccountResult
     */
    isConnected?: boolean;
}

/**
 * Check if a given object implements the JumboStructsEDRAccountResult interface.
 */
export function instanceOfJumboStructsEDRAccountResult(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function JumboStructsEDRAccountResultFromJSON(json: any): JumboStructsEDRAccountResult {
    return JumboStructsEDRAccountResultFromJSONTyped(json, false);
}

export function JumboStructsEDRAccountResultFromJSONTyped(json: any, ignoreDiscriminator: boolean): JumboStructsEDRAccountResult {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'createdAt': !exists(json, 'createdAt') ? undefined : json['createdAt'],
        'data': !exists(json, 'data') ? undefined : JumboStructsEDRAccountDataFromJSON(json['data']),
        'id': !exists(json, 'id') ? undefined : json['id'],
        'invalidatedAt': !exists(json, 'invalidatedAt') ? undefined : json['invalidatedAt'],
        'isConnected': !exists(json, 'isConnected') ? undefined : json['isConnected'],
    };
}

export function JumboStructsEDRAccountResultToJSON(value?: JumboStructsEDRAccountResult | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'createdAt': value.createdAt,
        'data': JumboStructsEDRAccountDataToJSON(value.data),
        'id': value.id,
        'invalidatedAt': value.invalidatedAt,
        'isConnected': value.isConnected,
    };
}

